import Sheet from "components/sheet/Sheet";
import { valueToString } from "helpers/Helpers";
import { MOBILE_WIDTH } from "helpers/ScreenSizes";
import { useWindowSize } from "hooks/useWindowSize/useWindowSize";
import moment from "moment";
import React from "react";
import { QRCode } from "react-qrcode-logo";
import { useTranslation } from "react-i18next";
import Panel from "components/panel/Panel";

interface IMembershipDetailsSheetProps {
  open: boolean;
  enableEmailAction: boolean;
  sheetTitle?: string;
  cardImageSrc: string;
  fullName: string;
  season?: string;
  membershipType: string;
  expiry?: string;
  membershipTitle: string;
  membershipSubtitle?: string;
  memberCode?: string;
  onCancel: () => void;
}

export default function MembershipDetailsSheet(props: IMembershipDetailsSheetProps) {
  const { t } = useTranslation();
  const {
    open,
    sheetTitle,
    cardImageSrc,
    fullName,
    season,
    membershipType,
    expiry,
    membershipTitle,
    membershipSubtitle,
    memberCode,
    onCancel,
  } = props;

  const windowSize = useWindowSize();

  function renderMembershipDetailsContent() {
    return (
      <>
        <div className="flex justify-center mb-4">
          <img src={cardImageSrc} style={{ width: "80%" }} />
        </div>
        <div className="flex justify-between">
          <div>{fullName}</div>
          {season ? (
            <div className="text-right">
              {t("{{season}} Season", {season})}
            </div>
          ) : null}
        </div>
        <div className="flex justify-between mb-2">
          <div className="text-gray-400 text-sm">{valueToString(membershipType)}</div>

          {expiry ? (
            <p className="text-gray-400 text-sm">
              {t("Expires on {{expiryDate}}", {expiryDate: moment(expiry).format("LL")})}
            </p>
          ) : null}
        </div>
        <div className="flex justify-between">
          <div>{membershipTitle}</div>
        </div>
        {membershipSubtitle ? (
          <div className="flex justify-between">
            <div className="text-gray-400 text-sm">{membershipSubtitle}</div>
          </div>
        ) : null}
        {memberCode ? (
          <div>
            <div className="flex justify-center mt-5 mb-2">
              <QRCode value={memberCode} size={180} eyeRadius={5} qrStyle="fluid" ecLevel="H" />
            </div>
            <div className="flex justify-center">{memberCode}</div>
          </div>
        ) : null}
      </>
    );
  }

  return (
    <>
      <Panel
        open={open && windowSize.width <= MOBILE_WIDTH}
        title={sheetTitle}
        onClose={onCancel}
        animate
        pagePercent={95}
        tertiaryAction={{
          onClick: onCancel,
          label: t("Close"),
        }}
      >
        {renderMembershipDetailsContent()}
      </Panel>
      <Sheet
        size="small"
        open={open && windowSize.width > MOBILE_WIDTH}
        title={sheetTitle}
        onCancel={onCancel}
        cancelText={t("Close")}
      >
        {renderMembershipDetailsContent()}
      </Sheet>
    </>
  );
}
